export default "__VITE_ASSET__D1HQk5gE__"